(ns ncr.etc.parse-dates
  (:require [clojure.string :as str]
            [goog.object :as gob]
            [tick.core :as t]
            [tick.locale-en-us]
            [cljc.java-time.local-date])
  (:import [goog.i18n DateTimeParse DateTimeSymbols DateTimeSymbols_de DateTimeSymbols_en DateTimeSymbols_fr]
           [goog.i18n.DateTimeFormat Format]))

;  FULL_DATE: 0, LONG_DATE: 1, MEDIUM_DATE: 2, SHORT_DATE: 3,
(def ^:private SHORT-DATE-FORMAT (.-SHORT_DATE Format))
(def ^:private MEDIUM-DATE-FORMAT (.-MEDIUM_DATE Format))
(def ^:private LONG-DATE-FORMAT (.-LONG_DATE Format))


(defn- get-symbols-pattern [^DateTimeSymbols symbols idx]
  (gob/get (.-DATEFORMATS symbols) idx))

(def ^:private SPECIAL-CASES
  [; Neckar: homegrown datetime format
   ["yyyy/M/d" DateTimeSymbols_en]
   ; Hetzner: using `dd/MM/yyyy`, which conflicts with EN `M/d/yyyy` pattern
   ["d/M/yyyy" DateTimeSymbols_en]
   ; ASF (France): using `dd/MM/yy` pattern
   ["dd/MM/yy" DateTimeSymbols_fr]
   ; reported by Tatiana
   ["dd-MM-yy" DateTimeSymbols_en]
   ; reported by Tatiana, Lisboa 23-11-12
   ["yy-MM-dd" DateTimeSymbols_en]
   ; reported by Tatiana, Italia, 2023-11-16
   ["yyyy-MM-dd" DateTimeSymbols_en]
   ; SSB: "15. February 2023" - mixing DE locale with EN month names
   [(get-symbols-pattern DateTimeSymbols_de LONG-DATE-FORMAT) DateTimeSymbols_en]])

(def ^:private OPTIONS
  (let [options (js/goog.i18n.DateTimeParse.ParseOptions.)]
    (set! (.-validate options) true)
    options))

(defn- strip-if-non-numeric-month [pattern input]
  (if (and (not (re-find #"[,.]" input)) (re-find #"MMM" pattern))
    (str/replace pattern #"[,.]" "")
    pattern))

(defn parse-with
  ([s pattern ^DateTimeSymbols symbols]
   (when symbols
     (set! (.-DateTimeSymbols goog.i18n) symbols))
   (let [result (js/Date. 0)
         pattern (if (and symbols (number? pattern)) (get-symbols-pattern symbols pattern) pattern)]
     (try
       (when (> (.parse (DateTimeParse. (strip-if-non-numeric-month pattern s)) s result OPTIONS) 0) result)
       (catch js/Error _ nil)))))

(defn combine [coll1 coll2]
  (mapcat (fn [x] (map (fn [y] [x y]) coll2)) coll1))

(defn sane-year? [date]
  (let [year (t/year date)]
    (when (and (>= year 1950) (<= year 2100))
      date)))

(defn parse-all [s]
  (sequence
    (comp (map #(some->> % (apply parse-with s) t/date sane-year?)) (filter identity) (dedupe))
    (concat
      (combine [SHORT-DATE-FORMAT MEDIUM-DATE-FORMAT LONG-DATE-FORMAT]
        [DateTimeSymbols_de DateTimeSymbols_en])
      SPECIAL-CASES)))

